import { connect } from 'react-redux';

import ConfirmationPage from './ConfirmationPage';

import {
    acknowledgeMessage as acknowledgeMessageAction,
    rejectMessage as rejectMessageAction,
} from '../../actions';

export const _mapStateToProps = (state) => ({
    forward: state.authentication.forward,
    usesNewStyles:
        state.authentication.featureFlags.launchAuthenticationRefactor,
});

export const _mapDispatchToProps = {
    onContinue: acknowledgeMessageAction,
    onCancel: rejectMessageAction,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(ConfirmationPage);
